import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { BookOpen, Plus, Search, MapPin, Building, Truck } from 'lucide-react';

const AddressBookPage = () => {
  // Placeholder address categories
  const categories = [
    { name: 'Delivery Addresses', count: 0, icon: Truck, color: 'text-blue-500 bg-blue-500/10' },
    { name: 'Supplier Addresses', count: 5, icon: Building, color: 'text-amber-500 bg-amber-500/10' },
    { name: 'Store Locations', count: 2, icon: MapPin, color: 'text-green-500 bg-green-500/10' },
  ];

  return (
    <div className="p-3 space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <h1 className="text-3xl font-semibold tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Address Book
          </h1>
          <p className="text-muted-foreground">Manage addresses for delivery, suppliers, and stores</p>
        </div>
        <Button>
          <Plus className="w-4 h-4 mr-2" />
          Add Address
        </Button>
      </div>

      {/* Search */}
      <Card className="border-white/10 bg-card">
        <CardContent className="pt-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              placeholder="Search addresses..."
              className="pl-10"
            />
          </div>
        </CardContent>
      </Card>

      {/* Address Categories */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {categories.map((category) => (
          <Card key={category.name} className="border-white/10 bg-card hover:bg-secondary/30 cursor-pointer transition-colors">
            <CardContent className="pt-6">
              <div className="flex items-center gap-4">
                <div className={`p-3 rounded-lg ${category.color}`}>
                  <category.icon className="w-6 h-6" />
                </div>
                <div>
                  <p className="font-semibold">{category.name}</p>
                  <p className="text-sm text-muted-foreground">{category.count} addresses</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Address List Placeholder */}
      <Card className="border-white/10 bg-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BookOpen className="w-5 h-5 text-amber-500" />
            All Addresses
          </CardTitle>
          <CardDescription>Manage all saved addresses in one place</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-muted-foreground">
            <MapPin className="w-16 h-16 mx-auto mb-4 opacity-50" />
            <h3 className="text-lg font-medium mb-2">No Custom Addresses Yet</h3>
            <p className="text-sm mb-4">Add delivery addresses, pickup locations, or other important addresses</p>
            <Button variant="outline">
              <Plus className="w-4 h-4 mr-2" />
              Add Your First Address
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card className="border-dashed border-2 border-slate-300 dark:border-slate-700 bg-transparent">
        <CardContent className="py-8">
          <div className="text-center text-muted-foreground">
            <p className="text-sm">🚧 Address Book functionality coming soon</p>
            <p className="text-xs mt-1">This page will allow you to manage shipping addresses, store locations, and supplier addresses</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AddressBookPage;
